export enum ImageQuality {
    THUMB_NORMAL = 'thumb_n',
    THUMB_HOVER = 'thumb_h',
    LOW = 'low',
    MEDIUM = 'med',
    HIGH = 'high',
}
